import { httpClient, type FileDownloadResponse } from '@/api/httpClient';

export const extractFilenameFromContentDisposition = (contentDisposition: string | null) => {
  if (!contentDisposition) {
    return undefined;
  }

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].replaceAll('"', '').trim());
  }

  const filenameMatch = /filename="?([^";]+)"?/i.exec(contentDisposition);

  return filenameMatch?.[1]?.trim();
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const downloadAuthenticatedFile = async (url: string, fallbackFilename: string) => {
  const response = await httpClient<FileDownloadResponse>(url, { responseType: 'blob' });
  const filename =
    extractFilenameFromContentDisposition(response.headers.get('Content-Disposition')) ??
    fallbackFilename;

  downloadBlob(response.blob, filename);
};
